import React from 'react';

export default (props) => {
  return (
    <nav className={props.className ? props.className : ''}>
      {props.children}
    </nav>
  )
}
